export default __webpack_public_path__ + "static/media/paul-modal.51eb0594.jpg";